import { component$, useContext } from '@builder.io/qwik';
import ArticleCoverImage from '../ArticleCover/ArticleCoverImage';
import { ArticleContext } from '~/contexts/ArticleContext';
import CameraIcon from '~/icons/camera';
import KyivShareButton from '~/components/Layout/Body/Article/ArticleShare/KyivShareButton';

export default component$(() => {
  const article = useContext(ArticleContext);

  if (!article) return <></>;

  const credit = article.cover?.image.value.credit;

  return (
    <header class={`relative z-10 w-full text-center mb-8`}>
      <ArticleCoverImage />
      <div class='absolute w-full h-full top-0 left-0 bg-[linear-gradient(0deg,rgba(26,26,26,0.7)_0%,rgba(0,0,0,0)_100%)]'></div>
      <div class='absolute bottom-14 md:bottom-20 w-full'>
        <h1 class='font-normal font-family-huge text-[30px] leading-[40px] lg:text-[50px] lg:leading-[70px] px-10 text-white'>
          {article.title}
        </h1>
      </div>
      <div class='absolute w-full bottom-0 flex justify-between items-center p-2 md:p-5'>
        <figure class='flex items-center gap-2'>
          <CameraIcon cssClasses='fill-white' />
          <figcaption
            class='text-white font-bold text-xs'
            dangerouslySetInnerHTML={credit}
          />
        </figure>
        <KyivShareButton />
      </div>
    </header>
  );
});
